@let noPatternsAndNaFilter =
  !(hasMatches$ | async) && (filterName$ | async) === 'n.a.';
@let activeTabIsPattern = activeTab === patternMatchTab;
@let activeTabIsMrq = activeTab === mrqReports;
@let hasPatternMatches = hasMatches$ | async;
@let isItMagnetSystem$ = (filterName$ | async) === 'Magnet System';
@let mrqDashboardUrl = patternMatchDataService.mrqDashboardUrl$ | async;

<api-call-gate [apiCall]="pmAnalysis">
  <ng-template #lastSuccessfulData let-data>
    @if (isItMagnetSystem$) {
      <section>
        <sh-tabs role="tablist">
          <sh-tab-item
            label="{{ patternMatchTab | translate }}"
            [active]="activeTabIsPattern"
            (click)="activateTab(patternMatchTab)"
            (keydown.enter)="activateTab(patternMatchTab)"
            [badge]="hasPatternMatches ? 'warning' : null"
            item
          >
            ></sh-tab-item
          >
          <sh-tab-item
            label="{{ mrqReports | translate }}"
            [active]="activeTabIsMrq"
            (click)="activateTab(mrqReports)"
            (keydown.enter)="activateTab(mrqReports)"
          ></sh-tab-item>
        </sh-tabs>
      </section>
    }

    @if (activeTabIsPattern) {
      @if (hasMatches$ | async) {
        <div class="chart">
          <div class="header">
            <sh-text size="header-2" color="primary">
              {{
                (filterName$ | async) === 'n.a.'
                  ? ('label.sevenDays' | translate)
                  : (data.componentName === 'X-Ray System'
                      ? 'X-ray System'
                      : data.componentName) +
                    ' ' +
                    ('label.patternMatches' | translate)
              }}
            </sh-text>
            <div class="tag-container">
              @if (selectedRow$ | async; as row) {
                <sh-tag
                  removable
                  (closed)="selectedRow$.next(undefined)"
                  [label]="row.patternDescription"
                ></sh-tag>
              }
              @if (selectedBar$ | async; as bar) {
                <sh-tag
                  removable
                  (closed)="selectedBar$.next(undefined)"
                  [label]="'Date: ' + (bar.bin.date | localizedDate)"
                ></sh-tag>
              }
            </div>
          </div>
          <pm-chart
            [bins]="(binnedResults$ | async)?.bins"
            (itemHovered)="hoveredItem = $event"
            (itemClicked)="barClicked($event)"
          ></pm-chart>
        </div>

        <!--  the table to hide when we are showing it in the component overview -->
        @if (isComponentStringInUrl()) {
          <div class="table">
            <sh-text size="header-2" color="primary"
              >Matches aggregated by Pattern Type</sh-text
            >

            <app-pm-table
              [patternMatches]="(binnedResults$ | async)?.patternMatches"
              [selectedRow]="selectedRow$ | async"
              [selectedBar]="selectedBar$ | async"
              [hoveredBar]="hoveredItem"
              (rowClicked)="rowClicked($event)"
            ></app-pm-table>
          </div>
        }
      } @else {
        <div class="empty">
          @if ((filterName$ | async) !== 'n.a.') {
            <sh-text size="header-2" color="primary">
              {{
                data.componentName === 'X-Ray System'
                  ? 'X-ray System'
                  : data.componentName
              }}
              Pattern Hits
            </sh-text>
          }
          <div>
            @if (noPatternsAndNaFilter) {
              <app-no-data-icon
                iconName="success"
                error="{{ 'label.noComponentDataPatternMatch' | translate }}"
                iconColor="{{ iconColor }}"
              ></app-no-data-icon>
            } @else {
              <app-no-data-icon
                iconName="success"
                error="{{ 'label.noDataPatternMatch' | translate }}"
                iconColor="{{ iconColor }}"
              ></app-no-data-icon>
            }

            <span
              >Date Range:
              <b>{{ (fixedDateRange$ | async)?.min | localizedDate }}</b> -
              <b>{{ (fixedDateRange$ | async)?.max | localizedDate }}</b></span
            >
          </div>
        </div>
      }
    }

    @if (activeTabIsMrq) {
      <div class="mrq-container">
        <div class="mrq-header">
          <sh-text size="header-2" color="primary" class="mrq-header-text">
            {{
              mrqMagnetType === '4K'
                ? '4K'
                : mrqMagnetType === '10K'
                  ? '10K'
                  : 'DryCool'
            }}
            {{ 'label.magnetPressure' | translate }}
          </sh-text>
          <div class="mrq-button-container">
            <sh-button
              class="mrq-dashboard-button"
              label="MRQ Dashboard"
              size="l"
              color="secondary"
              icon="trending-graph"
              icon-position="left"
              (click)="openDashboardInNewWindow(mrqDashboardUrl)"
            ></sh-button>
            <tippy-tooltip [content]="currentMagnetLegend">
              <sh-icon icon="information" size="m" style="color: red"></sh-icon>
            </tippy-tooltip>
          </div>
        </div>

        <app-mrq-table
          [magnetType]="mrqMagnetType"
          [reportData]="mrqReportData"
          [loading]="mrqLoading"
        ></app-mrq-table>
      </div>
    }
  </ng-template>
</api-call-gate>
